<button
  class="btn btn-app-primary btn-app-{{icon}} btn-app-{{size}} {{fullWidth ? 'w-100' : 'w-auto'}} btn-app-{{color}}"
  type="button"
  [disabled]="disabled"
>
  <ng-content></ng-content>
</button>
